import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-16 pb-20 px-4 md:pt-24 md:pb-32 overflow-hidden" data-id="element-42">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-zenith-red/10 rounded-full blur-[120px] pointer-events-none" data-id="element-43" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-44">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-45">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-46">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-47">
              La Ingeniería de la{' '}
              <span className="text-zenith-red" data-id="element-48">Estrategia Crediticia</span> DIY
            </h1>

            <h2 className="text-xl md:text-2xl font-medium text-zenith-muted mb-8 font-sans leading-relaxed" data-id="element-49">
              Cómo Auditar, Estructurar y Fortalecer tu Perfil Financiero en 30
              Días sin Pagar Agencias.
            </h2>

            <div className="bg-zenith-card border border-white/10 p-6 rounded-xl mb-10 shadow-2xl" data-id="element-50">
              <p className="text-lg font-bold text-white mb-3 font-serif italic" data-id="element-51">
                "El Conocimiento es el Único Activo que los Burós Temen."
              </p>
              <p className="text-zenith-muted leading-relaxed" data-id="element-52">
                Un ebook de 60 páginas con el proceso exacto para que TÚ tomes
                el control de tu propio reporte crediticio. Sin agencias. Sin
                contratos. Sin promesas vacías. Solo educación pura y acción.
              </p>
            </div>

            <CTAButton data-id="element-53" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative order-1 lg:order-2 flex justify-center" data-id="element-54">
            <div className="relative w-full max-w-md" data-id="element-55">
              <div className="absolute inset-0 bg-gradient-to-tr from-zenith-red/20 to-transparent rounded-2xl blur-2xl" data-id="element-56" />
              <img src="https://cdn.magicpatterns.com/uploads/8ZeZEM9KLUZi82upkfY4KH/credit_portada.png" alt="Protocolo Zenith Ebook Cover" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-57" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}